import request from '@/utils/request'
const qs = require('qs')

// 获取最近聊天记录
export function getmessagepage (data) {
  return request({
    url: '/ooh-search/v1/im/getmessagepage',
    method: 'post',
    data: qs.stringify(data),
    timeout: 200000
  })
}
